export default __webpack_public_path__ + "static/media/effects.1d352002.png";